"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumSelectInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const select_1 = require("../../select");
const EnumSelectInput = props => {
    const { name, options = [], prefix } = props;
    return (0, jsx_runtime_1.jsx)(select_1.SelectInput, { name: name, options: options, prefix: prefix });
};
exports.EnumSelectInput = EnumSelectInput;
//# sourceMappingURL=index.js.map